import React from 'react';
import { Award, Heart, Lightbulb, Zap } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  const valueIcons = {
    0: Award,
    1: Heart,
    2: Lightbulb,
    3: Zap
  };

  return (
    <div className="min-h-screen pt-16 bg-hermes-400">
      {/* Logo fixe en haut à gauche */}
      <div className="fixed top-24 left-8 z-40">
        <img 
          src="/logo-quid-novi.png" 
          alt="Quid Novi" 
          className="h-20 w-20"
        />
      </div>

      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6">
            {t.about.title}
          </h1>
          <p className="text-xl text-white/90 font-medium">
            {t.about.subtitle}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            {t.about.content.map((paragraph, index) => (
              <p key={index} className="text-lg text-white/90 leading-relaxed mb-6">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-serif font-bold text-white mb-4">
              {t.about.values.title}
            </h2>
            <div className="w-24 h-1 bg-white mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {t.about.values.items.map((value, index) => {
              const Icon = valueIcons[index];
              return (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 group hover:bg-white/20 transition-all"
                >
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center group-hover:bg-white/30 transition-colors">
                        <Icon className="w-7 h-7 text-white" strokeWidth={1.5} />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-3">
                        {value.title}
                      </h3>
                      <p className="text-white/80 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-hermes-600">
        <div className="max-w-4xl mx-auto text-center">
          <blockquote className="text-2xl md:text-3xl font-serif italic leading-relaxed text-white">
            "La transmission du savoir est au cœur de notre mission éditoriale."
          </blockquote>
          <p className="mt-6 text-hermes-100 text-lg">L'équipe Quid Novi</p>
        </div>
      </section>
    </div>
  );
};

export default About;
